// extracted by mini-css-extract-plugin
module.exports = {"adStyle":"ad_adStyle__26j_L","adStyleWrapper":"ad_adStyleWrapper__3vjtc","adProperties":"ad_adProperties__2Lmp7"};